import { render } from "./EnterThings.vue?vue&type=template&id=0cf473f1&scoped=true"
import script from "./EnterThings.vue?vue&type=script&lang=js"
export * from "./EnterThings.vue?vue&type=script&lang=js"

import "./EnterThings.vue?vue&type=style&index=0&id=0cf473f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf473f1"]])

export default __exports__